module.exports = __webpack_public_path__ + "static/img/shuiguo.608c3c4d.svg";